var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDarkIc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.7194 11.8244C19.4821 11.6383 19.1555 11.6149 18.894 11.7652C17.6539 12.478 16.3431 12.8395 14.9981 12.8395C10.6765 12.8395 7.16069 9.32353 7.16069 5.00182C7.16069 3.6509 7.52267 2.34191 8.23666 1.11135C8.38829 0.850101 8.3658 0.522852 8.17983 0.284692C7.99396 0.0465319 7.6819 -0.0547898 7.39165 0.0290694C5.30395 0.630883 3.42491 1.90771 2.10072 3.62426C0.726418 5.40593 0 7.5397 0 9.79502C0 15.422 4.57773 20 10.2046 20C12.4599 20 14.5942 19.2739 16.3767 17.9C18.0945 16.5761 19.3719 14.6981 19.9737 12.6119C20.0574 12.322 19.9567 12.0106 19.7194 11.8244ZM10.2046 18.52C5.39373 18.52 1.47987 14.606 1.47987 9.79502C1.47987 6.54937 3.3371 3.59575 6.15981 2.11134C5.84134 3.04711 5.68082 4.01386 5.68082 5.00182C5.68082 10.1395 9.86056 14.3194 14.9981 14.3194C15.9847 14.3194 16.9531 14.1582 17.8934 13.8386C16.4092 16.6619 13.453 18.52 10.2046 18.52Z",
    fill: "#00BCE7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkIc);
export default __webpack_public_path__ + "static/media/dark-ic.b7e4c1c11e5f2d63988a96c65b42bf85.svg";
export { ForwardRef as ReactComponent };